import React from 'react'
import { MdArrowBack } from "react-icons/md";

const PageNotFound = () => {
    return (
        <div className='flex flex-col justify-center items-center mt-32'>
            <h2 className='text-[160px] font-black'>404</h2>
            <p className='text-3xl'>Page Not Found</p>
            <button className='border rounded-[5px] px-3 py-0.5 flex justify-center items-center gap-1 bg-[#1F2937] text-white hover:bg-slate-600 hover:text-white mt-8'><MdArrowBack />Back to home</button>
        </div>
    )
}

export default PageNotFound;